class Alerts {
    constructor( component ) {
        this.snackbar = component.$root.$refs.app.$refs.snackbar;

        this.noAction();
    }

    setTimeout( timeout ) {
        this.snackbar.timeout = timeout;

        return this;
    }

    setType( type ) {
        this.snackbar.type = type;

        return this;
    }

    setMessage( message ) {
        this.snackbar.message = message;

        return this;
    }

    noAction() {
        this.setTimeout( 5000 );

        this.snackbar.is_action_visible = false;

        return this;
    }

    hasAction() {
        this.setTimeout( -1 );

        this.snackbar.is_action_visible = true;

        return this;
    }

    setActionText( text ) {
        this.snackbar.action_text = text;

        return this;
    }

    setAction( cb ) {
        this.snackbar.action_cb = cb;

        return this;
    }

    show() {
        this.snackbar.is_visible = true;
    }

    hide() {
        this.snackbar.is_visible = false;
    }

    simple( message ) {
        this.setMessage( message ).show();
    }
}

export class ErrorAlert extends Alerts {
    constructor( component ) {
        super( component );

        this.setType( 'error' );
    }
}

export class WarningAlert extends Alerts {
    constructor( component ) {
        super( component );

        this.setType( 'warning' );
    }
}

export class SuccessAlert extends Alerts {
    constructor( component ) {
        super( component );

        this.setType( 'success' );
    }
}
